import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    // this.element.click();
    Turbo.visit(this.element.getAttribute('href'), { action: 'replace' });
  }
}
